export enum SalaryFrequencyEnum {
    MONTHLY = 'MONTHLY',
    DAILY = 'DAILY',
    HOURLY = 'HOURLY',
}